export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    // 获取所有登录类型
    appLoginTypeRes: function appLoginTypeRes(data) {
      return request({
        url: '/appLogin/appLoginTypeRes',
        method: 'get',
        data: data
      });
    },
    // 登录类型列表
    appLoginTypeData: function appLoginTypeData(data) {
      return request({
        url: '/appLogin/appLoginTypeData',
        method: 'get',
        data: data
      });
    },
    // 登陆类型新增
    appLoginTypeAdd: function appLoginTypeAdd(data) {
      return request({
        url: '/appLogin/appLoginTypeAdd',
        method: 'post',
        data: data
      });
    },
    // 登陆类型修改
    appLoginTypeUpdate: function appLoginTypeUpdate(data) {
      return request({
        url: '/appLogin/appLoginTypeUpdate',
        method: 'post',
        data: data
      });
    },
    // 登陆类型删除
    appLoginTypeDel: function appLoginTypeDel(data) {
      return request({
        url: '/appLogin/appLoginTypeDel',
        method: 'post',
        data: data
      });
    },
    // 登录类型配置列表
    appLoginTypeConfigData: function appLoginTypeConfigData(data) {
      return request({
        url: '/appLoginTypeConfig/appLoginTypeConfigData',
        method: 'get',
        data: data
      });
    },
    // 登录类型配置列表
    appLoginTypeConfigDataNoPage: function appLoginTypeConfigDataNoPage(data) {
      return request({
        url: '/appLoginTypeConfig/appLoginTypeConfigDataNoPage',
        method: 'get',
        data: data
      });
    },
    // 登陆类型配置新增
    appLoginTypeConfigAdd: function appLoginTypeConfigAdd(data) {
      return request({
        url: '/appLoginTypeConfig/appLoginTypeConfigAdd',
        method: 'post',
        data: data
      });
    },
    // 登陆类型配置修改
    appLoginTypeConfigUpd: function appLoginTypeConfigUpd(data) {
      return request({
        url: '/appLoginTypeConfig/appLoginTypeConfigUpdate',
        method: 'post',
        data: data
      });
    },
    // 登陆类型配置删除
    appLoginTypeConfigDel: function appLoginTypeConfigDel(data) {
      return request({
        url: '/appLoginTypeConfig/appLoginTypeConfigDel',
        method: 'post',
        data: data
      });
    },
    // 登录配置列表 
    appLoginSdkConfigData: function appLoginSdkConfigData(data) {
      return request({
        url: '/apLoginSdkConfig/appLoginSdkConfigData',
        method: 'get',
        data: data
      });
    },
    // 登陆配置新增
    appLoginSdkConfigAdd: function appLoginSdkConfigAdd(data) {
      return request({
        url: '/apLoginSdkConfig/appLoginSdkConfigAdd',
        method: 'post',
        data: data
      });
    },
    // 登陆配置修改
    appLoginSdkConfigUpdate: function appLoginSdkConfigUpdate(data) {
      return request({
        url: '/apLoginSdkConfig/appLoginSdkConfigUpdate',
        method: 'post',
        data: data
      });
    },
    // 登陆配置删除
    appLoginSdkConfigDel: function appLoginSdkConfigDel(data) {
      return request({
        url: '/apLoginSdkConfig/appLoginSdkConfigDel',
        method: 'post',
        data: data
      });
    },
    // 重置
    resetLogin: function resetLogin(data) {
      return request({
        url: '/apLoginSdkConfig/resetLogin',
        method: 'post',
        data: data
      });
    },
    // 登录参数切换列表
    appLoginReplaceListData: function appLoginReplaceListData(data) {
      return request({
        url: '/appLoginReplaceList/appLoginReplaceListData',
        method: 'get',
        data: data
      });
    },
    // 登录参数切换新增
    appLoginReplaceListAdd: function appLoginReplaceListAdd(data) {
      return request({
        url: '/appLoginReplaceList/appLoginReplaceListAdd',
        method: 'post',
        data: data
      });
    },
    // 登录参数切换修改
    appLoginReplaceListUpdate: function appLoginReplaceListUpdate(data) {
      return request({
        url: '/appLoginReplaceList/appLoginReplaceListUpdate',
        method: 'post',
        data: data
      });
    },
    // 登录参数切换删除
    appLoginReplaceListDel: function appLoginReplaceListDel(data) {
      return request({
        url: '/appLoginReplaceList/appLoginReplaceListDel',
        method: 'post',
        data: data
      });
    },
    // 用户列表
    LoginDatauserData: function LoginDatauserData(data) {
      return request({
        url: '/sdkLoginDataList/userData',
        method: 'get',
        data: data
      });
    },
    // 修改用户状态
    loginUserBan: function loginUserBan(data) {
      return request({
        url: '/sdkLoginDataList/loginUserBan',
        method: 'post',
        data: data
      });
    },
    // 账号实名列表
    userRealNameList: function userRealNameList(data) {
      return request({
        url: '/sdkLoginDataList/userRealNameList',
        method: 'get',
        data: data
      });
    },
    // 账号登录列表
    accountList: function accountList(data) {
      return request({
        url: '/sdkLoginDataList/accountList',
        method: 'get',
        data: data
      });
    },
    // 邮箱登录列表
    emailList: function emailList(data) {
      return request({
        url: '/sdkLoginDataList/emailList',
        method: 'get',
        data: data
      });
    },
    // 第三方登录列表
    oauthList: function oauthList(data) {
      return request({
        url: '/sdkLoginDataList/oauthList',
        method: 'get',
        data: data
      });
    },
    // 手机登录列表
    phoneList: function phoneList(data) {
      return request({
        url: '/sdkLoginDataList/phoneList',
        method: 'get',
        data: data
      });
    },
    // 修改手机号码
    updatePhone: function updatePhone(data) {
      return request({
        url: '/sdkLoginDataList/updatePhone',
        method: 'post',
        data: data
      });
    },
    // 游客登录详情
    visitorList: function visitorList(data) {
      return request({
        url: '/sdkLoginDataList/visitorList',
        method: 'get',
        data: data
      });
    },
    // 登陆类型配置新增
    appLoginTypeConfigUpdateSortBy: function appLoginTypeConfigUpdateSortBy(data) {
      return request({
        url: '/appLoginTypeConfig/appLoginTypeConfigUpdateSortBy',
        method: 'post',
        data: data
      });
    },
    // 获取用户是否有关联的手机号
    getUserByPhone: function getUserByPhone(data) {
      return request({
        url: '/sdkLoginDataList/getUserByPhone',
        method: 'post',
        data: data
      });
    },
    // 修改绑定手机号
    otherUpdatePhone: function otherUpdatePhone(data) {
      return request({
        url: '/sdkLoginDataList/otherUpdatePhone',
        method: 'post',
        data: data
      });
    },
    // 应用版本登录类型配置
    appVersionLoginTypeList: function appVersionLoginTypeList(data) {
      return request({
        url: '/appLoginReplaceList/appVersionLoginTypeList',
        method: 'get',
        data: data
      });
    },
    addAppVersionLoginType: function addAppVersionLoginType(data) {
      return request({
        url: '/appLoginReplaceList/addAppVersionLoginType',
        method: 'post',
        data: data
      });
    },
    updateAppVersionLoginType: function updateAppVersionLoginType(data) {
      return request({
        url: '/appLoginReplaceList/updateAppVersionLoginType',
        method: 'post',
        data: data
      });
    },
    delAppVersionLoginType: function delAppVersionLoginType(data) {
      return request({
        url: '/appLoginReplaceList/delAppVersionLoginType',
        method: 'post',
        data: data
      });
    },
    appVersionLoginTypeUpdateSortBy: function appVersionLoginTypeUpdateSortBy(data) {
      return request({
        url: '/appLoginTypeConfig/appVersionLoginTypeUpdateSortBy',
        method: 'post',
        data: data
      });
    },
    appReviewConfigData: function appReviewConfigData(data) {
      return request({
        url: '/appReview/appReviewConfigData',
        method: 'get',
        data: data
      });
    },
    appReviewConfigAdd: function appReviewConfigAdd(data) {
      return request({
        url: '/appReview/appReviewConfigAdd',
        method: 'post',
        data: data
      });
    },
    appReviewConfigUpdate: function appReviewConfigUpdate(data) {
      return request({
        url: '/appReview/appReviewConfigUpdate',
        method: 'post',
        data: data
      });
    },
    appReviewConfigDel: function appReviewConfigDel(data) {
      return request({
        url: '/appReview/appReviewConfigDel',
        method: 'post',
        data: data
      });
    },
    appUserAgreementData: function appUserAgreementData(data) {
      return request({
        url: '/appUserAgreement/appUserAgreementData',
        method: 'get',
        data: data
      });
    },
    appUserAgreementAdd: function appUserAgreementAdd(data) {
      return request({
        url: '/appUserAgreement/appUserAgreementAdd',
        method: 'post',
        data: data
      });
    },
    appUserAgreementUpdate: function appUserAgreementUpdate(data) {
      return request({
        url: '/appUserAgreement/appUserAgreementUpdate',
        method: 'post',
        data: data
      });
    },
    appUserAgreementDel: function appUserAgreementDel(data) {
      return request({
        url: '/appUserAgreement/appUserAgreementDel',
        method: 'post',
        data: data
      });
    }
  };
});